<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`出车费用汇总表`)">导出</el-button>
          <!-- 导出图片按钮 -->
          <el-button :loading="btnloading" type="primary" @click="getExport">导出图片</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :showTotal="true" :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceExpenseSummary",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      breadcrumb: [
        { name: "财务管理" },
        { name: "出车费用汇总表" },
      ],
      formCtrl: [
        {
          ...this.ctrls.month
        },
        {
          label: "车队长",
          keyName: "fleet",
          type: "select",
          options: [],
        },
        {
          label: "车种",
          keyName: "car_type_id",
          type: "select",
          options: [],
        },
        {
          label: "预支款类型",
          keyName: "prepaid_type_id",
          type: "select",
          options: [],
        },
        {
          ...this.ctrls.license
        },
      ],
      cols: [
        // 添加一个默认列用来占位，防止没有数据时表格异常
        { prop: "license", label: "车牌号", minwidth: '110px' },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          title: '费用明细',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ license }) => {
            this.$router.push(
              `/finance/tabledetails?license=${license}`
            );
          },
        },
      ],
      baseParams: ['month'],
      formInline: { month: '' },
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `carall/expicture`;
      const params = {
        // userid: this.user.id,
        month: this.formInline.month,
      }
      this.post(url, params, (res) => {
        const { msg, url } = res
        if (msg === 'success' && url) {
          // console.log(res)
          var link = document.createElement('a')
          link.href = url
          link.click()
        } else {
          this.$message({
            type: 'error',
            message: msg || '导出失败，请稍后再试！',
          });
        }
        this.btnloading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSearchItemChange({ key, value }) {
      if (['fleet', 'month'].includes(key)) {
        this.getList()
      } else if (key == 'car_type_id') {
        console.log(key, value)
        this.getPrepaidType(value)
      }
    },
    getPrepaidType(car_type_id) {
      let url = `car/getprepaidtype`;
      const params = {
        car_type_id,
      }
      this.post(url, params, ({ msg, prepaid_type }) => {
        if (msg) {
          console.log('prepaid_type', [...prepaid_type])
          this.formCtrl.map((c) => {
            if (c.keyName == "prepaid_type_id" && prepaid_type && prepaid_type.length) {
              c.options = prepaid_type.map((v) => {
                return {
                  label: v.name,
                  value: v.id,
                };
              });
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
      })
    },
    setOptions({ team, month, dayauth, prepaid_type, car_type }) {
      this.MONTH = month
      if (!this.formInline.month) {
        this.$set(this.formInline, 'month', month)
      }
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet' && team && team.length) {
          v.options = team.map(c => {
            return {
              label: c.nickname,
              value: c.id,
            }
          })
        } else if (v.keyName === 'prepaid_type_id' && prepaid_type && prepaid_type.length) {
          v.options = prepaid_type.map(c => {
            return {
              label: c.name,
              value: c.id,
            }
          })
        } else if (v.keyName == "car_type_id" && car_type && car_type.length) {
          v.options = car_type.map((v) => {
            return {
              label: v.name,
              value: v.id,
            };
          });
        }
      })

      const arr = []
      dayauth.map(v => {
        const o = {
          prop: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          width: '100px',
        }
        if (v.authname.length > 3) {
          o.width = 100
        }
        arr.push(o)
      })
      this.cols = [
        { prop: "license", label: "车牌号", minwidth: '110px' },
        { prop: "month", label: "月份" },
        ...arr,
        { prop: "doil", label: "现金加油", align: 'right', className: 'pr30', width: '110px' },
        { prop: "moneydoil", label: "油气卡加油", align: 'right', className: 'pr30', width: '120px' },
        { prop: "total", label: "合计", align: 'right', className: 'pr30', width: '110px' },
      ]
      this.getTotalProperty = [
        ...arr.map(v => v.prop), 'doil', 'moneydoil', 'total'
      ]
      this.doLayout()
      this.$forceUpdate()
      console.log({ ...this.formInline })
      this.getList()
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getOptions()
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>